import React from 'react';
import styled from 'styled-components';
import { DefaultAvatar } from '@components/basics/default-avatar';
import { Typography } from '@components/basics/typography';
import { ImageRetry } from '@components/basics/image-retry';

type AvatarImageProps = {
  more?: number;
  name?: string;
  src?: string;
  alt?: string;
  size?: string;
};

export const AvatarImage = (props: AvatarImageProps) => {
  return (
    <Container size={props.size}>
      {props.more !== 0 && props.more ? (
        <div className="more">
          <Typography className="text-avatar" weight="700">
            +{props.more}
          </Typography>
        </div>
      ) : props.name ? (
        <div className="name">
          <Typography className="text-avatar" weight="700">
            {props.name}
          </Typography>
        </div>
      ) : props.src ? (
        <AvatarImg alt={props.alt} src={props.src} />
      ) : (
        <DefaultAvatar />
      )}
    </Container>
  );
};

const Container = styled.div<{ size?: string }>`
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: 50%;
  width: ${(props) => (props.size ? props.size : '32')}px;
  height: ${(props) => (props.size ? props.size : '32')}px;

  &.bordered {
    border: 1px solid ${({ theme }) => theme.colors.box};
  }

  .more {
    text-align: center;
    color: ${({ theme }) => theme.colors.differentBackground};
    background-color: ${({ theme }) => theme.colors.secondaryHover};
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    span {
      margin: 0 auto;
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const AvatarImg = styled(ImageRetry)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
`;
